import ContainerValidation from "../Components/ContainerValidation";
import HeaderValidation from "../Components/HeaderValidation";
import routes from "../../../../../Routes/routes";
import {getUrlParameters, TAB_INDEX} from "../Model/Model";
import BodyValidation from "../Components/BodyValidation";
import StepContainer from "./SubComponents/StepContainer";
import React from "react";
import {CreateDocumentationApp} from "./Functionality/CreateDocumentationApp";
import useForbiddenValidation from "../Functionality/useForbiddenValidation";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const CreateDocumentation = () => {

    const {
        t,
        guardFlowId,
        loading,
        btnDisabled,
        getInvitationById,
        steps,
        activeStep,
        StepLoading,
        handleClickNext,
        handleChange,
        data,
        emptyFields,
        photoPickerList,
        setPhotoPickerList,
        handleDeletePhotoPicker,
        isValidData
    } = CreateDocumentationApp()

    useForbiddenValidation({ getInvitationById, documentationFlow: true });

    return (<>
        <ContainerValidation>
            <HeaderValidation
                activeStep={activeStep}
                showBtnBack = {activeStep !== TAB_INDEX.THREE}
                steps={steps?.TOTAL}
                url={getUrlParameters({ url:routes.invitationDetails.documentationValidation, id:getInvitationById?.invitation?.id, guardFlowId })}
                headerCenter={
                    <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center align-self-center gap-1">
                        <p className="fs-16-to-14 ibl-font-w-600 font-color-general-950 text-center">{t("visitor_documentation")}</p>
                        <p className="fs-16-to-14 ibl-font-w-600 font-color-general-950 d-none d-sm-block">{"•"}</p>
                        <p className="fs-16-to-12 ibl-font-w-400 font-color-general-950 text-center">{`${t("step")} ${activeStep} ${t("of")} ${steps?.TOTAL - 1} `}</p>
                    </div>
                }
            />

            <BodyValidation
                click={() => {
                    handleClickNext();
                }}
                showBtnNext={activeStep !== TAB_INDEX.THREE}
                btnDisabled={btnDisabled}
                classWith={'content-center-w-800px gap-4'}
            >
                <div className="w-100">
                    { steps && (
                        <StepContainer
                            stepModel={steps}
                            activeStep={activeStep}
                            t={t}
                            loading={loading}
                            getInvitationById={getInvitationById}
                            data={data}
                            handleChange={handleChange}
                            emptyFields={emptyFields}
                            StepLoading={StepLoading}
                            photoPickerList={photoPickerList}
                            setPhotoPickerList={setPhotoPickerList}
                            handleDeletePhotoPicker={handleDeletePhotoPicker}
                            isValidData={isValidData}
                        />
                    )}
                </div>
            </BodyValidation>
        </ContainerValidation>
    </>)
}
export default CreateDocumentation
